export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./settingsDialog.vue?vue&type=template&id=0161026d&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/settingsDialog.vue?vue&type=template&id=0161026d&
// module id = null
// module chunks = 